export default __webpack_public_path__ + "static/media/AMS Master History2.fdd6f50f.svg";